import { Search } from "lucide-react";
import { Button } from "@themes/pollinator/ui/Button";

export type Props = {
  onClick: () => void;
};

export function SupportSidebarSearchButton({ onClick }: Props) {
  return (
    <Button
      onClick={onClick}
      className="w-full"
      variant="secondary"
      iconComponent={Search}
      data-testid="support-sidebar-search-open-modal"
    >
      Search Support
    </Button>
  );
}

export default SupportSidebarSearchButton;

